module.exports = __webpack_public_path__ + "static/media/pink.766335eb.svg";